import React from 'react'
import PropTypes from 'prop-types'
import { Line } from 'rc-progress'

import Icon from 'Pods/Shared/Icon/Icon'

function UploadProgress({ fileName, progress, isProcessing }) {
  return (
    <div className="upload-progress">
      <div className="upload-progress__header">
        <div className="upload-progress__info">
          {fileName}
          <span className="upload-progress__percent text-semibold">
            {progress}%
            {isProcessing && (' processing...')}
          </span>
        </div>
        {/* TODO: prepare cancel upload functionality later */}
        {/* <Icon type={['far', 'times']} className="ml-5" /> */}
      </div>

      <Line percent={progress} strokeWidth="0.8" trailWidth="0.8" strokeColor="#67c4b0" />
    </div>
  )
}

UploadProgress.propTypes = {
  fileName: PropTypes.string.isRequired,
  progress: PropTypes.number.isRequired,
  isProcessing: PropTypes.bool,
}

UploadProgress.dafaultProps = {
  isProcessing: false,
}

export default UploadProgress
